import useSetState from "ahooks/lib/useSetState";
import { PropsWithChildren } from "react";
import { PasswordKitBEM } from ".";
const keys = [1, 2, 3, 4, 5, 6, 7, 8, 9, "", 0, "删除"];
export type PasswordKitKeyBoardProps = PropsWithChildren<{
  onChange?: (text: string) => void;
}>;
export const PasswordKitKeyBoard = ({
  onChange
}: PasswordKitKeyBoardProps) => {
  const b = PasswordKitBEM;
  return <div className={b("keyboard")} data-sentry-component="PasswordKitKeyBoard" data-sentry-source-file="keyboard.tsx">
      {keys.map(key => {
      return <button className={b("keyboard-item", {
        nobg: key === "删除",
        nokey: key === ""
      })} onClick={e => {
        onChange?.(String(key));
        e.stopPropagation();
        e.preventDefault();
      }} onMouseDown={e => {
        e.preventDefault();
      }} key={key}>
            {key}
          </button>;
    })}
    </div>;
};